/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Detail_Available_SlotsInputs */

const en_job_detail_available_slots = /** @type {(inputs: Job_Detail_Available_SlotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available appointments`)
};

const de_job_detail_available_slots = /** @type {(inputs: Job_Detail_Available_SlotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbare Termine`)
};

/**
* | output |
* | --- |
* | "Available appointments" |
*
* @param {Job_Detail_Available_SlotsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_detail_available_slots = /** @type {((inputs?: Job_Detail_Available_SlotsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Detail_Available_SlotsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_detail_available_slots(inputs)
	return en_job_detail_available_slots(inputs)
});